function compress(data) {
    var q = {}, ret = "";
    data.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
        q[key] = (q[key] ? q[key] + "," : "") + value;
    });
    for (var key in q)
        ret = (ret ? ret + "&" : "") + key + "=" + q[key];
    return ret;
}

function filterSerialize() {
    return compress($("#FilterForm").serialize() + "&" + $("#GridIcons > li > input[type=radio]").serialize());
}

function isScrolledIntoView(elem) {

    var $elem = $(elem);
    var $window = $(window);
    if ($elem.offset() != undefined) {
        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();
        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();
        return (((elemBottom - 750) <= (docViewBottom)));
    }

}

function ChangeHashedStringParamValue(params, removedParam, newValue) {


    if (params != undefined && params.length > 0) {

        var splitStr = (removedParam + "=");
        var newParamsArray = params.split(splitStr);

        if (newParamsArray.length >= 2) {
            var firstPartOfParams = newParamsArray[0];
            var secondPartOfParams = "";
            var beginCalc = false;
            for (var i = 0; i < newParamsArray[1].length; i++) {

                if (beginCalc) {
                    secondPartOfParams += newParamsArray[1][i];
                }

                if (newParamsArray[1][i] == "&") {
                    beginCalc = true;
                }


            }

            params = firstPartOfParams + removedParam + "=" + newValue + "&" + secondPartOfParams;

        }

    }

    return params;

}

function GetQuickLookEvents() {
    $("#QuickLookModal .SmallProductImages img").live("click", function () {
        var ImageIndex = $(this).index();
        $("#QuickLookModal .ProductDetailImages ul li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).removeClass("gizli");
                $(this).find("a img").attr("src", $(this).find("a img").data("src"));
            }
            else {
                $(this).addClass("gizli");
            }


        });
        $("#QuickLookModal .SmallProductImages img").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("Selected");
            } else {
                $(this).removeClass("Selected");
            }


        });


    });

}

function LeftMenuFixedOptions() {
    $(window).scroll(function () {
        var TopValue = $("footer").height();

        if ($(window).scrollTop() + ($(window).height() + 300) > $(document).height()) {
            $(".CategoryLeftBar").css("top", "-" + (TopValue) + "px");

        } else {

            $(".CategoryLeftBar").css("top", "inherit");
        }
    });
}


//function GetLeftCatalogList() {

//    $curCatalog = $("#MainNewMenu a[data-rel='" + $("#PID").val() + "']");

//    if ($curCatalog.length > 0) {
//        $curUL = $curCatalog.closest(".itemsWrapper").closest("li").first().clone();

//        if ($curUL.length < 1) {
//            $curUL = $curCatalog.closest("li").first().clone();
//        }

//        $(".leftCatalogList").html("");
//        $(".leftCatalogList").append($curUL);

//        $selectedCats = $("#MainNewMenu a[data-rel='" + $("#PID").val() + "']");
//        $selectedCats2 = $("#SubCatNavs a[data-rel='" + $("#PID").val() + "']");

//        $selectedCats2.css("font-weight", "bold");
//        $selectedCats2.css("color", "#797979");

//        if ($selectedCats2.parent().parent().parent().hasClass("ListWrapper")) {
//            $selectedCats2.parent().addClass("opened");
//        } else {
//            $selectedCats2.parent().closest("div").parent().addClass("opened");
//        }

//    }

//    $(".SubCatNavs>li .itemsWrapper .ListWrapper>ul>").each(function () {

//        if ($(this).find("div").length == 0) {
//            $(this).addClass("hidePlusIcon");
//        }
//    });

//}

function GetNewLeftCatalogList() {

    var root = document.querySelector(".leftCatalogList");
}


function GetLeftCatalogList() {

    $curCatalog = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");

    if ($curCatalog.length > 0) {
        $curUL = $curCatalog.closest(".itemsWrapper").closest("li").first().clone();

        if ($curUL.length < 1) {
            $curUL = $curCatalog.closest("li").first().clone();
        }

        $(".leftCatalogList").html("");
        $(".leftCatalogList").append($curUL);

        $selectedCats = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");
        $selectedCats2 = $("#SubCatNavs a[data-rel='" + $("#PID").val() + "']");

        $selectedCats2.css("font-weight", "bold");
        $selectedCats2.css("color", "#797979");

        if ($selectedCats2.parent().parent().parent().hasClass("ListWrapper")) {
            $selectedCats2.parent().addClass("opened");
        } else {
            $selectedCats2.parent().closest("div").parent().addClass("opened");
        }

    }

    $(".SubCatNavs>li .itemsWrapper .ListWrapper>ul>").each(function () {

        if ($(this).find("div").length == 0) {
            $(this).addClass("hidePlusIcon");
        }
    });

    //LeftMenuFixedOptions();
}

function ToggleLeftBarItems() {
    if ($(window).width() > 767) {
        $(".itemsWrapper > .ListWrapper > ul > li").live("click", function () {
            $(".itemsWrapper  .ListWrapper  ul  li").not(this).removeClass("opened");
            $(this).toggleClass("opened");
        });
    }


}

function ToggleLeftBar() {
    $(".FilterForm .filterLink").live("click", function () {
        $(this).parent().find(".FilterBoxes").slideToggle();
        $(this).toggleClass("toggle-minus");

    });

    $(".SubCatNavs > li > a").live("click", function (e) {
        $(this).parent().find(".itemsWrapper").slideToggle();
        $(this).parent().toggleClass("toggle-minus");
        e.preventDefault;
        return false;
    });

}

function GetAddaxCardPriceForQuickLook() {

    var Amount2 = $("#ForMemberCardAmount2").val();
    var OldAmount2 = $("#ForMemberCardOldAmount2").val();
    var MemberCardGroupID2 = $("#MemberCardGroupID").val();
    var ForMemberCardCurrencyCode2 = $("#ForMemberCardCurrencyCode2").val();
    if (Amount2 != undefined && OldAmount2 != undefined && MemberCardGroupID2 != undefined && ForMemberCardCurrencyCode2 != undefined && MemberCardGroupID2 != -1) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetMemberCardPrice",
            data: 'Amount=' + Amount2 + "&AmountOld=" + OldAmount2 + "&MemberCardGroupID=" + MemberCardGroupID2,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.TotalAmount != "0" && dt.TotalAmount != 0) {
                    $("#QuickLookModal .RPrice").html(dt.TotalAmount + " " + ForMemberCardCurrencyCode2);
                    $("#QuickLookModal .AddaxCardPrice").css("display", "inline-block");
                }

            }
        });
    }

}

function MarkToLastVisitedProducts() {

    var LastVisitedProducts = localStorage.LastVisitedProducts;

    if (LastVisitedProducts == undefined) {
        LastVisitedProducts = [];
    } else {
        LastVisitedProducts = JSON.parse(LastVisitedProducts);
    }

    //console.log(LastVisitedProducts);

    $(".Products .ProductList .Prd > .productImageWrapper > a").each(function (index) {
        var that = $(this);

        $.each(LastVisitedProducts, function (index, value) {
            if (that.attr("data-product") == LastVisitedProducts[index].ProductID && that.attr("data-color") == LastVisitedProducts[index].ColorID) {
                if (that.find(".Viewed").length <= 0) {
                    that.append("<span class='Viewed'>" + $("#Incelendi").val() + "</span>");
                }

            }
        });
    });

}

function SetPriceSlider() {
    var IsAutoScrollOpen = Boolean($("#AutoScroll").val());
    if ($(".CatalogLeftMenu").length > 0) {


        var slider = document.getElementById('PriceSlider');
        var min = $("#MinPrice").val();
        var max = $("#MaxPrice").val();

        noUiSlider.create(slider, {
            start: [min, max],
            connect: true,
            step: 1,
            range: {
                'min': parseInt(min),
                'max': parseInt(max)
            }
        });

        slider.noUiSlider.on('change', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $("#SliderValue").val(Math.round(values[0]) + "-" + Math.round(values[1]));


            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }

            window.location.hash = filterSerialize();
        });

        slider.noUiSlider.on('update', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $(".priceView").html("").html(Math.round(values[0]) + " " + $("#CurrencyCode").val() + " - " + Math.round(values[1]) + " " + $("#CurrencyCode").val());
        });

    }

}

function SetFixedLeftBarHeigt() {

    var windowHeight = ($(window).height() - 150);
    if ($(window).width() > 991) {
        $("#SubCatNavs").height(windowHeight);
    }


}

//function HammerActions() {
//    var toggleFilterElem = document.getElementById('ToogleFilters');
//    var hammer = new Hammer(toggleFilterElem);
//    // Hammer Event Listener 
//    hammer.on("tap", function (ev) {
//        $("#FilterForm").slideToggle();
//    });
//}

function FilterRefresh() {

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/Cat/CatFilter",
        data: filterSerialize(),
        success: function (dt) {
            $("#LeftWrapper").html(dt);
            GetLeftCatalogList();
            SetPriceSlider();
        }
    })

}

function leftCatalogClick() {

    $(document).on("click", ".leftCatalogList > li > a", function (e) {

        $(this).closest(".leftCatalogList").find(" > li > .itemsWrapper").slideToggle();
        $(this).toggleClass("minusIcon");
        e.preventDefault();
        return false;
    });

}

function TitleChange(pageNo) {

    if ($("body").hasClass("Cat")) {

        var PageHandler = /( - Sayfa| - Page) \d+/g;
        var titleVal = document.title;
        titleVal = titleVal.replace(PageHandler, '');
        var sayfa = " - Sayfa ";
        if ($("#SmallLangCode").val() == "en") {
            sayfa = " - Page ";
        }

        document.title = titleVal + sayfa + pageNo;

        var metaDesc = $("meta[name=description]").attr("content");
        metaDesc = metaDesc.replace(PageHandler, '');
        $("meta[name=description]").attr("content", metaDesc + sayfa + pageNo);
    }

}

function GetQuickLookModal(ProductID, ColorID) {

    $Modal = $("div#QuickLookModal");

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
        data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
        success: function (dt) {

            $("div#QuickLookModal .modal-body").html(dt);
            $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");


        }
    });

    $Modal.modal("show");
    return false;
    e.preventDefault();

}



var delay = (function () {
    var WhoSalesTimer = 0;
    return function (callback, ms) {
        clearTimeout(WhoSalesTimer);
        WhoSalesTimer = setTimeout(callback, ms);
    };
})();


function CheckWholeSaleFormValidation(form) {
    $("#AlertResult").hide();
    $("#WholeSalesModal input[type=number]").closest("span").removeClass("validationHiglight");
    $("#AlertResult").find("ul").html("");
    var sum = 0;

    form.find("input[type=number]").each(function () {
        $that = $(this);

        sum += Number($that.val());

        if (!$(this).context.checkValidity()) {

            $("#" + $that.context.id).closest("span").addClass("validationHiglight");
            $("#AlertResult").find("ul").append("<li>• " + $that.context.validationMessage + " (<strong> " + $that.data("colorname") + " - " + $that.data("sizename") + " </strong>)</li>");
            $("#AlertResult").show();
            return false;

        }


    });

    if (sum <= 0) {
        $("#AlertResult").find("ul").append("<li>• " + $("#UrunYok").val() + "</li>");
        $("#AlertResult").show();
        return false;
    }

    return true;
}

function WholeSalesMode() {

    $(document).on("click", "#WholeSalesModal #AlertResult .closeButton", function () {
        $("#WholeSalesModal input[type=number]").closest("span").removeClass("validationHiglight");
        $(this).closest("#AlertResult").hide();
    });


    $(document).on("click", ".PrdImgRight,.PrdImgLeft", function () {
        var currentSelected = $(this).parent().find("ul li.selected");

        if ($(this).hasClass("PrdImgRight")) {

            if (currentSelected.index() == $(".ImagesWrapper ul li").last().index()) {
                $(this).parent().find("ul li").removeClass("selected");
                $(".ImagesWrapper ul li").first().addClass("selected");
            } else {
                $(this).parent().find("ul li").removeClass("selected");
                currentSelected.next().addClass("selected");
            }

        }
        if ($(this).hasClass("PrdImgLeft")) {
            if (currentSelected.index() == $(".ImagesWrapper ul li").first().index()) {
                $(this).parent().find("ul li").removeClass("selected");
                $(".ImagesWrapper ul li").last().addClass("selected");
            } else {
                $(this).parent().find("ul li").removeClass("selected");
                currentSelected.prev().addClass("selected");
            }

        }
    });

    $(document).on("click", ".colorRow ul li a", function () {

        var that = $(this);
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetImagesOfColorHtml",
            data: "ColorID=" + $(this).attr("data-colorid") + "&ProductID=" + $(this).attr("data-productid"),
            cache: false,
            success: function (dt) {

                var images = dt.map(function (item, index) {
                    var itemClass = ""
                    if (index == 0) {
                        itemClass = "selected";
                    }

                    return $('<li class="' + itemClass + '"><img style="width: 100%;" src="' + item.ImagePath.replace("_buyuk.jpg", "_detay.jpg") + '"/></li>')
                });
                $(".stockImages > .ImagesWrapper > ul").html(images);
                $(".colorRow ul li a").removeClass('selected');
                that.addClass('selected');

            }
        });


    });

    $(document).on("click", "#WholeSalesFormSubmit", function (e) {
        e.preventDefault();

        var $theForm = $(this).closest('form');

        var validationResult = CheckWholeSaleFormValidation($theForm);

        if (((typeof ($theForm[0].checkValidity) == "function") && !$theForm[0].checkValidity()) || !validationResult) {
            return;
        }
        else {

            AjaxWLoaderStart($("#AddingLoaderMessage").val());
            $.ajax({
                type: "POST",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/WholeSales",
                data: $(this).closest("form").serialize(),
                cache: false,
                success: function (dt) {

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {
                            AjaxWLoaderEnd();
                            $("#WholeSalesModal").modal("toggle");
                            $(".BasketContainer").html(dt);

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            $("body").addClass("BasketDropped");
                            setContentHeight();


                        }
                    });

                }
            });
        }



    });

    //$(document).on("click", ".WholeSalesCalc", function (e) {
    $(document).on("keyup", "#WholeSalesModal input[type=number]", function (e) {
        e.preventDefault();
        var that = $(this);
        var $theForm = $(this).closest('form');

        delay(function () {

            var validationResult = CheckWholeSaleFormValidation($theForm);
            if (((typeof ($theForm[0].checkValidity) == "function") && !$theForm[0].checkValidity()) || !validationResult) {
                return;
            }
            else {

                AjaxWLoaderStart($("#CalcLoaderMessage").val());
                $.ajax({
                    type: "POST",
                    url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/WholeSalesCalc",
                    data: $theForm.closest("form").serialize(),
                    cache: false,
                    success: function (dt) {

                        if (dt != null && typeof (dt) == "object") {
                            //console.log(dt);
                            $(".WholeSalesCalcResult div .AmountText").html(dt.Amount + " " + dt.CurrencyCode);
                            $(".WholeSalesCalcResult div .TotalBenefitAmountText").html(dt.Benefit + " " + dt.CurrencyCode);
                            $(".WholeSalesCalcResult .TotalListPrice").html(dt.TotalAmount + " " + dt.CurrencyCode);
                            $(".WholeSaleDiscountRate").html(dt.DiscountRate);
                            var SubTotalVal = 0;
                            var activeTr = that.closest("tr");
                            activeTr.find("td.QuantityColumn").each(function () {
                                SubTotalVal += parseInt($(this).find(".QuantityInput").val());
                            });
                            activeTr.find(".TotalColumn .SubTotalQuantity").html(SubTotalVal);

                            var TotalVal = 0;
                            $(".TotalColumn .SubTotalQuantityWrapper .SubTotalQuantity").each(function () {
                                TotalVal += parseInt($(this).html());
                            });
                            $(".TotalQuantity span").html(TotalVal);



                        }
                        AjaxWLoaderEnd();

                    }
                });
            }
        }, 500);


    });

    $(document).on("click", ".AddToCartWrapper > button,td.addButtonRow a,.Prd a", function () {

        var colorid = $(this).attr("data-colorid") || $(this).attr("data-color")
        var productid = $(this).attr("data-productid") || $(this).attr("data-product")

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/WholeSales",
            data: "ProductID=" + productid + "&ColorID=" + colorid,
            cache: false,
            success: function (dt) {
                $("#WholeSalesModal .modal-body").html(dt);
                $("#WholeSalesModal").modal();
            }
        });

    });

}

var isNewRequestAllowed = true;
var isFirstLoad = false;
var LoadPage = 1;




$(document).ready(function () {

    //TitleChange(1);
    var IsAutoScrollOpen = Boolean($("#AutoScroll").val());

    if (IsAutoScrollOpen) {

        $(".Pages").hide();
    }
    //console.log("'"+$(".CatFirstPart").html()+"'");

    if ($(".CatFirstPart").html() != undefined
        && $(".CatFirstPart").html() != null
        && $(".CatFirstPart").html() != ""
        && $(".CatFirstPart").html() != " "
       ) {

        if ($(window).width() < 992) {
            $(".CatFirstPart").textSummary({ maxlength: 55, morechar: "" });
        } else {
            $(".CatFirstPart").textSummary({ maxlength: 220, morechar: "" });
        }

    }


    function GetHashParamValue(param) {

        if (window.location.hash.indexOf("&" + param + "=") == -1) {
            return "";
        }

        var nmVL = window.location.hash.split("&" + param + "=");
        return nmVL[1].split("&")[0];

    }

    GetQuickLookEvents();
    GetLeftCatalogList();
    ToggleLeftBarItems();
    ToggleLeftBar();
    //SetFixedLeftBarHeigt();
    MarkToLastVisitedProducts();
    SetPriceSlider();
    leftCatalogClick();
    WholeSalesMode();

    //if ($(".Cat.Index").length > 0 || $(".Cat.NewSearch").length > 0) {
    //    if ($(".dortyuzdort").length <= 0) {
    //        HammerActions();
    //    }

    //}

    //$(window).on("resize", function () {
    //    SetFixedLeftBarHeigt();
    //});


    if ($(window).width() > 991) {
        $(".PageWidth").attr("value", "1");
    } else {
        $(".PageWidth").attr("value", "2");
    }

    $(window).on("resize", function () {

        if ($(window).width() > 991) {
            $(".PageWidth").attr("value", "1");

        } else {
            $(".PageWidth").attr("value", "2");
        }
    });


    var ScrollContentID = "LastScrollTop" + $("#PID").val();
    var LastScrollTop = $.cookie(ScrollContentID);

    if (window.location.hash != undefined && window.location.hash.length > 0) {

        isFirstLoad = true;
        LoadPage = Number(GetHashParamValue("p"));
    }


    var grd = GetHashParamValue("g");


    if ($(window).width() < 767 && grd != undefined && grd == "") {


        var $checked = $("#GridIcons input[value='6']");
        $checked.closest("li.gr").find("label").addClass("c_on checked");

        $checked.prop("checked", true);
    }

    $(window).bind('hashchange', function (e) {

        var hs = window.location.hash;

        var params = hs.replace("#", "");

        if (hs == "#_=_") {

            window.location.hash = "";
            document.location.href = "";
        }

        if ($("form#FilterForm").length > 0 && $("#Tag").length == 0 || $("#CombineList").length > 0) {

            //&& $("#sr").length == 0


            $gizlenecekSecim = $(".Products");
            //$gizlenecekSecim.css("opacity", "0.1");
            $(".AjaxLoader").show();

            var nmVL = params.split("&");

            for (var i = 0; i < nmVL.length; i++) {


                var nmVL2 = nmVL[i].split("=");


                for (var j = 0; j < nmVL2.length; j++) {


                    if (nmVL2[0] == "u") {

                        $("select#u option").removeAttr("selected");
                        $("select#u option[value='" + nmVL2[1] + "']").prop("selected", true);


                        $("#PrdItemNo input, #PrdItemNo label").removeAttr("checked");
                        $("#PrdItemNo input, #PrdItemNo label").removeClass("checked");
                        $("#PrdItemNo input, #PrdItemNo label").removeClass("c_on");

                        var $checked = $("#PrdItemNo input[value='" + nmVL2[1] + "']");
                        $checked.prop("checked", true);

                        $checked.parent().find("label").addClass("checked");
                        $checked.parent().find("label").addClass("c_on");
                        $(".FlinkItemCount").text($checked.parent().find("label").text());
                    }

                    if (nmVL2[0] == "o") {

                        $("#PrdSort input, #PrdSort label").removeAttr("checked");
                        $("#PrdSort input, #PrdSort label").removeClass("checked");
                        $("#PrdSort input, #PrdSort label").removeClass("c_on");

                        var $checked = $("#PrdSort input[value='" + nmVL2[1] + "']");
                        $checked.prop("checked", true);

                        $checked.parent().find("label").addClass("checked");
                        $checked.parent().find("label").addClass("c_on");
                        //$(".fLinkSortNo").html($checked.parent().find("label").text() + "<div class='plus-Icon'></div>");

                    }

                    //console.log(nmVL2)
                    if (nmVL2[0] == "g") {

                        $("#GridIcons input, #GridIcons label").removeAttr("checked");
                        $("#GridIcons input, #GridIcons label").removeClass("checked");
                        $("#GridIcons input, #GridIcons label").removeClass("c_on");

                        var $checked = $("#GridIcons input[value='" + nmVL2[1] + "']");
                        $checked.prop("checked", true);

                        $checked.parent().find("label").addClass("checked");
                        $checked.parent().find("label").addClass("c_on");

                    }

                    var filterSelector = "none";
                    if (nmVL2[0] == "sc") filterSelector = "sc";
                    if (nmVL2[0] == "c") filterSelector = "cl";
                    if (nmVL2[0] == "b") filterSelector = "mr";
                    if (nmVL2[0] == "sty") filterSelector = "sty";
                    if (nmVL2[0] == "s") filterSelector = "sz";

                    //if (nmVL2[0] == "prc") {

                    //    $("input#prc").attr("data-slider-value", "[" + nmVL2[1] + "]");
                    //    var vlDefault = $("input#prc").attr("data-slider-value").replace("[", "").replace("]", "").split("-");
                    //    $("input#prc").attr("value", vlDefault[0] + '-' + vlDefault[1]);

                    //    //$("input#prc").val(nmVL2[1].split('-')[1]); 

                    //}

                    if (filterSelector != "none") {

                        $(".fil" + filterSelector + " label").removeAttr("checked");
                        $(".fil" + filterSelector + "  input").removeClass("checked");
                        $(".fil" + filterSelector + "  label").removeClass("c_on");


                        var ParamValues = nmVL2[1].split(",");

                        for (var q = 0; q < ParamValues.length; q++) {

                            var $checked = $(".fil" + filterSelector + " input[value='" + ParamValues[q] + "']");
                            $checked.prop("checked", true);

                            $checked.parent().find("label").addClass("checked");
                            $checked.parent().find("label").addClass("c_on");

                            $(".fil" + filterSelector).closest("div").find(".RemoveFilter").show();

                        }




                    }


                }


            }

            //var NewGrid = GetHashParamValue("g");

            if (params == undefined || params == null || params == "") {

                existParams = filterSerialize();
                params = existParams.replace("#", "");


            }

            if (params != undefined && params != null) {

                $(".AjaxLoader").show();
                isNewRequestAllowed = false;

                var defAdress = "/Home/GetProductList";

                if ($("#CombineList").length > 0) {
                    defAdress = "/Cat/Combines";
                }

                //calculate all loaded pages till current page
                if (isFirstLoad && LoadPage > 1) {
                    var uParam = GetHashParamValue("u");
                    if (uParam == undefined || uParam == "") {
                        uParam = 1;
                    }
                    else {
                        uParam = Number(uParam);
                    }

                    var newUParam = LoadPage * uParam;

                    params = ChangeHashedStringParamValue(params, "u", newUParam);
                    params = ChangeHashedStringParamValue(params, "p", 1);


                }
                var lastindex = 0;



                $.ajax({
                    type: "GET",
                    url: "/" + $("#SmallLangCode").val() + "/p" + defAdress,
                    data: params,
                    cache: false,
                    success: function (data) {

                        //$gizlenecekSecim.animate({
                        //    opacity: 1
                        //}, 500, function () {

                        //});

                        $(".AjaxLoader").hide();

                        isNewRequestAllowed = true;

                        if (IsAutoScrollOpen && !isFirstLoad) {

                            if ($(".ProductList .NotFound").length <= 0) {

                                if ($("#GridIcons li label.checked").parent().find("input").val() == 3) {
                                    $(".ProductColumn").removeClass("col-md-16");
                                    $(".ProductColumn").addClass("col-md-19");
                                } else {
                                    $(".ProductColumn").removeClass("col-md-19");
                                    $(".ProductColumn").addClass("col-md-16");
                                }

                                $(".Products").append(data);
                                //$(".FilterForm .FilterBoxes").hide();

                                //BEGIN - Filtreden seçim yapıldığında toplam ürün sayısını güncelliyoruz.
                                var totalProductCount = $(".Products #ProductCountTotal").text();
                                $("#TotalProduct .TotalProductCountText").html(totalProductCount);
                                //END

                            }

                            $(".Pages:first").html($(".Products .Pages:eq(2)").html());

                            $(".Products .Pages:gt(0)").remove();

                            if (IsAutoScrollOpen && $("#CombineList").length <= 0) {

                                $(".Pages").hide();
                            }

                            isFirstLoad = false;

                            lastindex = $(".Products .ProductList").length;

                            if (UseTagManager && lastindex != undefined) {
                                AddFilterEvent(),
                                AddImpression('');
                                SendGaDataLayerVirtual();
                            }

                            //FilterRefresh();
                        }
                        else {

                            if ($("#GridIcons li label.checked").parent().find("input").val() == 3) {
                                $(".ProductColumn").removeClass("col-md-16");
                                $(".ProductColumn").addClass("col-md-19");
                            } else {
                                $(".ProductColumn").removeClass("col-md-19");
                                $(".ProductColumn").addClass("col-md-16");
                            }

                            $(".Products").html(data);

                            //BEGIN - Filtreden seçim yapıldığında toplam ürün sayısını güncelliyoruz.
                            var totalProductCount = $(".Products #ProductCountTotal").text();
                            $("#TotalProduct .TotalProductCountText").html(totalProductCount);
                            //END

                            isFirstLoad = false;

                            if (LastScrollTop != undefined && LastScrollTop.length > 0) {
                                LastScrollTop = Number(LastScrollTop);

                                $('html, body').animate({
                                    scrollTop: LastScrollTop
                                }, 500);

                                $.cookie(ScrollContentID, null, { expires: -1 });

                            }
                            //FilterRefresh();
                        }

                        //

                        if ($(".CatBannerContainer").length > 0 && $(".backdrop").length > 0) {

                            $(".PrdContainer .ProductList .Prd").addClass("col-sm-12");

                            if ($("#GridIcons .gr input:checked:first").val() != "4") {
                                $(".PrdContainer .ProductList .Prd").removeClass("col-xs-24").addClass("col-xs-12");
                            }
                            else {
                                $(".PrdContainer .ProductList .Prd").removeClass("col-xs-12").addClass("col-xs-24");
                            }
                        }


                    }

                });



            }

        }

    });


    var finished = false;


    $('#ColorFilters > li.colorfilter a').click(function (event) {

        $li = $(this).closest("li");

        if ($li.find("input:checked").length > 0) {

            $li.find("input").removeAttr("checked");
            $li.removeClass("selected");

        }
        else {

            $li.find("input").attr("checked", "checked");
            $li.addClass("selected");

        }

        $li.find("input").trigger("change");

    });

    $(".RemoveFilter").live("click", function () {

        $filterContainers = $(this).closest("div");

        if ($filterContainers.find("input:checked").length > 0) {

            $filterContainers.find("input").removeAttr("checked");
            $filterContainers.find("label").removeClass("checked");
            $filterContainers.find("label").removeClass("c_on");

        }

        $filterContainers.find("ul > li > input").trigger("change");

    });



    $('#ColorFilters > li input, #Styles > li input,#Deparments > li input, #Sizes > li input, #PrdSort > li input,  #Molds > li input, #PrdItemNo > li input, #GridIcons > li >  input[type=radio]').live("change", function (e) {
        //console.log("asdasd")

        $curIput = $(this);
        $curLi = $(this).closest("li");
        $curLabel = $curLi.find("label:first");

        if ($(this).hasClass("RemoveFilter")) {

            $filtercontainer = $(this).closest("div");

            if ($filtercontainer.find("input:checked").length > 0) {
                $filtercontainer.find("input").removeAttr("checked");
                $filtercontainer.find("label").removeClass("checked");
                $filtercontainer.find("label").removeClass("c_on");
            }
        }

        var GridVal = "";
        var SortVal = "";
        var ItemOnPage = "&u=" + $("#GridIcons #u").val();



        if ($(this).closest("#GridIcons").length > 0) {

            $("#GridIcons input").removeAttr("checked");
            $("#GridIcons label").removeClass("checked");
            $("#GridIcons label").removeClass("c_on");

            $curIput.attr("checked", "checked");
            $curLabel.addClass("c_on");

            GridVal = "&g=" + $curIput.val();

            if (IsAutoScrollOpen && GridVal != grd) {

                $(".Products").html("");
                grd = GridVal;
            }


        }

        if ($(this).closest("#PrdSort").length > 0) {

            SortVal = "&o=" + $curIput.val();

            $("#PrdSort input").removeAttr("checked");
            $("#PrdSort label").removeClass("checked");
            $("#PrdSort label").removeClass("c_on");

            $curIput.attr("checked", "checked");
            $curLabel.addClass("c_on");

            //$("#PrdSort").parent().hide();

            if ($(this).closest(".FilterSortBy").length > 0) {
                //$(this).closest("#PrdSort").parent().hide();
                //$(this).closest(".FilterSortBy").find(".filterLink").text($(this).find("label:first").text());
            }

            //$(".fLinkSortNo").text($("label", $(this)).text());

            if (IsAutoScrollOpen) {
                $(".Products").html("");
            }
        }

        if ($(this).closest("#Sizes").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }


        if ($(this).closest("#Styles").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }

        if ($(this).closest("#Departments").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }

        if ($(this).closest("#Molds").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }

        if ($(this).closest(".filcl").length > 0) {

            if (IsAutoScrollOpen) {
                $(".Products").html("");
            }
        }

        if ($(this).closest("#PrdItemNo").length > 0) {

            SortVal = "&u=" + $("input", $(this)).val();

            $("#PrdItemNo input").removeAttr("checked");
            $("#PrdItemNo label").removeClass("checked");
            $("#PrdItemNo label").removeClass("c_on");

            $curIput.attr("checked", "checked");
            $curLabel.addClass("c_on checked");

            $("#PrdItemNo").parent().hide();


            $(this).closest("#PrdItemNo").parent().hide();
            $(".FlinkItemCount").text($("input", $(this)).val());

            if (IsAutoScrollOpen) {
                $(".Products").html("");
            }

        }

        if ($curLi.find("input:first").is(':checked')) {
            $curLi.find("input").attr("checked", "checked");
            $curLi.find("label:first").addClass("c_on");
        }
        else {
            $curLi.find("input").removeAttr("checked");
            $curLi.find("label").removeClass("checked");
            $curLi.find("label").removeClass("c_on");

        }

        //console.log($(this).closest("form").serialize());
        window.location.hash = filterSerialize();

    });

    var a = window.location.hash;

    if ($("form#FilterForm").length > 0 && a == "" && $("#sr").length == 0 && $("#Tag").length == 0) {

        var pgNo = "1";

        if ($('.Pages a.selected').length > 0) {

            pgNo = $('.Pages a.selected:first').attr("data-pgno");
        }


        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        if (IsAutoScrollOpen) {

            var paramPgNo = GetHashParamValue("p");

            if (paramPgNo != undefined && paramPgNo.length > 0) {
                pgNo = pgNo;
            }

        }

        if (pgNo != "1" && (document.URL.indexOf("page=").length <= 0 || window.location.hash.length > 0)) {
            window.location.hash = filterSerialize() + "&p=" + pgNo;
            //TitleChange(pgNo);



        }

    }
    else if ($("form#FilterForm").length > 0 && a != "") {

        //change params on refresh
        var paramF = GetHashParamValue("f");

        if (paramF == "") {
            paramF = "&f=1";
        }
        else {
            paramF = "&f=" + (Number(paramF) + 1);
        }

        var curHash = a.split("&f=")[0] + paramF;


        window.location.hash = curHash;
    }

    $('.Pages a').live("click", function (e) {

        $curPage = $(this);

        if (IsAutoScrollOpen) {

            //$nextPage = $('.Pages a.selected').next(); 
            //$('.Pages a').removeClass("selected");
            //$nextPage.addClass("selected");


        } else {

            $('html, body').animate({
                scrollTop: $("div.row.Products").offset().top + -90
            }, 500);

        }

        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }


        if ($("#CombineList").length > 0) {

            window.location.hash = "p=" + $curPage.attr("data-pgno");
            //TitleChange(pgNo);

        }
        else {

            pgNo = $curPage.attr("data-pgno");

            if (IsAutoScrollOpen) {

                var paramPgNo = GetHashParamValue("p");

                if (paramPgNo != undefined && paramPgNo.length > 0) {
                    pgNo = Number(paramPgNo) + 1;
                }
            }

            window.location.hash = filterSerialize() + "&p=" + pgNo;
            //TitleChange(pgNo);

        }

        e.preventDefault;
        return false;

    });


    $('#GridIcons > #u').live("change", function () {
        //console.log("geldi");
        if (IsAutoScrollOpen == false) {
            $('html, body').animate({
                scrollTop: $("div.row.Products").offset().top
            }, 500);
        }


        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        $curPage(".Pages a.selected");

        pgNo = $curPage.attr("data-pgno");

        if (IsAutoScrollOpen) {

            var paramPgNo = GetHashParamValue("p");

            if (paramPgNo != undefined && paramPgNo.length > 0) {
                pgNo = Number(paramPgNo);
            }

        }

        window.location.hash = filterSerialize() + "&p=" + pgNo;
        //TitleChange(pgNo);
    });


    var hs1 = window.location.hash;

    if ($("form#FilterForm").length <= 0 && location.href.indexOf("ct=") != -1) {

        if (hs1 == "#_=_") {

            window.location.hash = "";
            document.location.href = "";
        }

        hs1 = hs1.replace("#", "");


        if ($("#" + hs1 + "").length > 0) {


            $("#ContactMap, #ContactInfo, #ContactForm").hide();

            $("#" + hs1 + "").show("slow");


        }
    }

    $("section.FilterOption ul>li>input[type=checkbox]").live("change", function () {

        if ($(this).is(':checked')) {
            $(this).next("label").addClass("checked");
        }
        else {
            $(this).next("label").removeClass("checked");
        }
    });

    if ($("ul#ColorFilters>li>label").exists) {

        $("ul#ColorFilters>li>label.Colored").each(function () {
            var c = $(this).css("background-color");
            var xColor = [];
            if (c.length <= 7) {
                xColor = [hexToRgb(c).r, hexToRgb(c).g, hexToRgb(c).b];
            }
            else {
                xColor = c.replace(/^(rgb|rgba)\(/, '').replace(/\)$/, '').replace(/\s/g, '').split(',');
            }

            $(this).css("color", RenkKontrol(xColor) ? "white" : "black");
        });
    }

    $('.CatShowMore').on('click', function (e, index) {

        $(this).hide();
        $('.CatShowLess').show();
        $('.CatSecondPart').show();
    });

    $('.CatShowLess').on('click', function (e, index) {

        $(this).hide();
        $('.CatShowMore').show();
        $('.CatSecondPart').hide();

    });

    if ($(".CatBannerContainer").length > 0 && $(".backdrop").length > 0) {

        $(".PrdContainer .ProductList .Prd").addClass("col-sm-12");
        $(".PrdContainer .ProductList .Prd").addClass("col-xs-12");

    }


    $curCatalog = $("#MainNewMenu a[data-rel='" + $("#PID").val() + "']");

    $("#QuickLookModal .ProductSuggestHeader").live("click", function (e) {

        $("#QuickLookModal .Productsuggest").toggle();
        $("#QuickLookModal .CombineInfoPd").toggle();

    });

    $(".QuickLookBtn").live("click", function (e) {


        var ProductID = $(this).data("productid");
        var ColorID = $(this).data("colorid");

        $Modal = $("div#QuickLookModal");
        $productLink = $(this).closest(".Prd").find("a").first().attr("href");


        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
            data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
            success: function (dt) {
                $("div#QuickLookModal .modal-body").html(dt);

                $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");
                $("#QuickLookModal .DropItems a:first-child").trigger("click");

                $("a.fullDetailBtn").live("click", function () {
                    window.location.href = $productLink;
                });


            }
        });


        $Modal.modal("show");

        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

            var swParams = GetSwPageParams();

            swParams = ChangeSwHashedStringParamValue(swParams, "ActionType", "UrunGoruntuleme");

            swParams = AddSwParam(swParams, "ProductID", ProductID);
            swParams = AddSwParam(swParams, "ColorID", ColorID);

            swParams = AddSwParam(swParams, "SubActionType", "HizliBakis");
            AddSwAction(swParams);

        }

        return false;
        e.preventDefault();


    });

    $('#QuickLookModal').on('shown.bs.modal', function () {
        GetAddaxCardPriceForQuickLook();

    });


    $(window).scroll(function () {

        var scroltoview = isScrolledIntoView($(".Products"));

        if (scroltoview && isNewRequestAllowed) {

            $nextPg = $(".Pages:first a.selected:first").next("a");

            if ($nextPg.length > 0 && $(".ProductList .NotFound").length <= 0) {

                $nextPg.trigger("click");

            } else {

                $("#CatalogEnded").show();
                $(".ProductList .NotFound").hide();
            }
        }


    });

});